<template>
    <div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
        <div v-if="loading">
			<spinner-component :loading="loading"/>
		</div>

        <div v-if="error" class="tx-center tx-danger">
			{{ error }}
		</div>

		<div class="row justify-content-center">
			<div class="col-12 mb-4" v-if="!loading">
				<div class="card ht-md-100p bd-0">
					<div class="card-header d-flex justify-content-between px-0 bd-b-0 sr-only">
						<h6 class="lh-5 mg-b-0">Approvals</h6>
					</div>
					<approval-list :approvals="approvals"></approval-list>
				</div>
			</div>
		</div>
    </div>
</template>

<style scoped>
	.card-header h6 {
		font-size: 1.09375rem;
	}
</style>

<script>
	export default {
		data() {
			return {
				loading: false,
				error: null,
				approvals: null,
			};
		},
		created() {
			this.fetchApprovals();
		},
		updated() {},
		computed: {},
		watch: {},
		methods: {
			fetchApprovals() {
				this.error = this.approvals = null;
				this.loading = true;

				axios
					.get(
						`/api/companies/${this.$store.getters.company.external_client_id}/approvals`
					)
					.then((response) => {
						const approvals = response.data.data.approvals;

						if (!_.isEmpty(approvals)) {
							this.approvals = approvals;
						}
					})
					.catch((error) => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = false;
					});
			},
		},
	};
</script>